/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.CertificateController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { GetCertificatesFromDuoResponse } from '../models/get-certificates-from-duo-response';

@Injectable()
export class CertificateApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public getCertificatesFromDuo(spinnerMessage: string = null): Observable<GetCertificatesFromDuoResponse> {
        return this.httpClient.get<GetCertificatesFromDuoResponse>(`/api/certificate/duo`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


}
